import React, { useState, useEffect, useRef } from 'react';
// Style
import { TakisCard, useStyles} from './TakisRecipeList.styles';
// Components
import Grid from '@material-ui/core/Grid';
import CardContent from '@material-ui/core/CardContent';
import PropTypes from 'prop-types';
import TakisPicture from './TakisPicture';
import TakisRecipeListItemsSkeleton from "../components/Skeletons/TakisRecipeListItemsSkeleton"
import TakisButton from '../components/TakisButton';
import Link from '@material-ui/core/Link';
import { TakisSvg } from '../components/TakisSvgs';
import Typography from '@material-ui/core/Typography';
// Hooks
import { useRecipesData } from '../hooks/useRecipesData';
import { useLanguage, supportedLanguages } from "../hooks/useLanguage";

function TakisRecipeList({pageType, title, recipeCTA, recipesPageCTA, initialRecipes = [], isStatic, isSectionTitle, propRecipes}) {
  const classes = useStyles();
    const [recipes, setRecipes] = useState(initialRecipes)
    const [disableLoadMore, setDisableLoadMore] = useState(false)
    const [pageNumber, setPageNumber] = useState(0)
    const [lastPage, setLastPage] = useState(0)
    const { recipesError, isLoading, recipesQueryData } = useRecipesData(pageNumber, pageType);
    const itemLimitPerPage = 6;
    const recipeLinks = useRef([]);
    const recipeList = useRef();
    const language = useLanguage();

    TakisRecipeList.propTypes = {
      title: PropTypes.string.isRequired,
      recipes: PropTypes.array,
      propRecipes: PropTypes.array,
      isStatic: PropTypes.bool,
      isSectionTitle: PropTypes.bool,
    };

    const getRecipeImages = (recipe) => (
      [
        {
          url: recipe.imageSrc,
          size: "mobile"
        },
        {
          url: recipe.imageSrc,
          size: "tablet"
        },
        {
          url: recipe.imageSrc,
          size: "desktop"
        }
      ]
    )

    useEffect(() => {
      if (isStatic && propRecipes !== undefined) {
        setRecipes(propRecipes)
      }
    }, [propRecipes, isStatic])

    useEffect(() => {
      if (pageNumber > lastPage) {
        // on page load
        // focus on newly loaded recipe
        const newRecipeIndex = pageNumber * itemLimitPerPage
        if (newRecipeIndex && recipeLinks.current?.[newRecipeIndex]) {
          recipeLinks.current[newRecipeIndex].focus()
        }
      }
    }, [recipes.length, recipeLinks, pageNumber, lastPage])

    useEffect(() => {
      const isLastPage = recipesQueryData && recipesQueryData.recipes.length < itemLimitPerPage;

      if (!recipesQueryData || (isStatic && pageNumber === 0)) {
        return
      }
      if (isLastPage) {
        setDisableLoadMore(true)
      }
      setRecipes([...recipes, ...recipesQueryData.recipes]);

    }, [recipesQueryData])

    const handleLoadMore = () => {
      if (!isStatic) {
        // focus last item before load
        recipeLinks.current[recipeLinks.current.length - 1].focus()
        setLastPage(pageNumber)
        setPageNumber(pageNumber + 1)

      }
    }

    let recipesLink = language === supportedLanguages.en ? "/recipes" : "/es/recetas"

    if (recipes.length > 0) {
      return (
        <div className={classes.recipeList} data-aos="fade-up">
          {
            isSectionTitle ?
            <h1
              className={`
                ${classes.title}
                ${isSectionTitle ? 'isSectionTitle' : ''}
              `}
              >
              {title}
            </h1> :
            <h2 className={classes.title}>{title}</h2>
          }
          <Grid
            className={classes.recipesContainer}
            container
            justifyContent="center"
            spacing={4}
            element="ul"
            ref={recipeList}
            >
            {recipes.map((recipe, index) => (
              <Grid
                container
                item
                key={index}
                sx={12}
                lg={6}
                element="li"
                >
                <TakisCard className={classes.recipe} border={1}>
                  <div className={classes.imageContainer}>
                    <TakisPicture
                      pictureClass={classes.image}
                      images={getRecipeImages(recipe)}
                      isLazy={false}
                      altText={recipe.title}
                    />
                  </div>
                  <CardContent className={classes.recipeContent}>
                    <Typography
                      className={classes.recipeTitle}
                      variant="h2"
                      component="h2">
                      {recipe.title}
                    </Typography>
                    <Link
                      className={classes.recipeCta}
                      href={recipe.cta.href}
                      aria-label={recipe.title + ", " + recipeCTA}
                      ref={(el) => {
                        recipeLinks.current[index] = el
                      }}
                      >
                      {recipeCTA}
                      <TakisSvg
                        icon="rightArrow"
                        svg_class={classes.recipeCtaIcon}
                        viewbox="0 0 32 32"
                        ariaHidden="true"
                        />
                    </Link>
                  </CardContent>
                </TakisCard>
              </Grid>
            ))}
            {
              (recipesError || isLoading) &&
              <TakisRecipeListItemsSkeleton/>
            }
          </Grid>
          {
            !disableLoadMore &&
            <TakisButton
              color="purpleButton"
              title={isStatic ? recipesPageCTA : "Load More"}
              alt={isStatic ? recipesPageCTA : "Load More"}
              ariaLabel={isStatic ? recipesPageCTA : "Load More"}
              type={isStatic ? 'link' : 'action'}
              href={isStatic && recipesLink}
              btnFunc={handleLoadMore}
            />
          }
        </div>
    );
    }
    return (<></>);

}

export default TakisRecipeList;
